import {spawnErrorToast} from '@hm/fundamental'
import type {AxiosError} from 'axios'
import {useTranslation} from 'react-i18next'

import {useRefraQuery} from '@refra/modules/common/hooks'
import type {ErrorResponse} from '@refra/modules/common/types'
import {logger} from '@refra/modules/common/utils'

interface UseMaterialInstallationDetailsQueryParams {
  plantUpmId: string
  kilnUpmId: string
  shutdownId: number
  installationId: number
}

export const useMaterialInstallationDetailsQuery = ({
  plantUpmId,
  kilnUpmId,
  shutdownId,
  installationId
}: UseMaterialInstallationDetailsQueryParams) => {
  const {t} = useTranslation()

  return useRefraQuery({
    queryKey: 'materialInstallationDetails',
    params: [{plantUpmId, kilnUpmId, shutdownId, installationId}],
    throwOnError: (error) => {
      const axiosError = error as AxiosError<ErrorResponse>
      const errorDetails =
        axiosError?.response?.data.detail ?? axiosError.message ?? axiosError.response?.status
      logger
        .context('useMaterialInstallationDetailsQuery')
        .extras({errorDetails})
        .error('Error occurred while fetching material installation details')

      spawnErrorToast(t('error.materialInstallationDetailsQuery'))

      return false
    }
  })
}
